import React from "react";
import { TurnrGrid } from "~/components/TurnrGrid.jsx";
import { TurnrTableCell, TurnrTableRow } from "~/components/table/TurnrTableSmart.jsx";
import AvatarAndItemName from "~/components/items/AvatarAndItemName.jsx";
import { CustomerComplaintInfo } from "~/components/Complaint.jsx";
import { CHIP_COLOR_TYPES, CustomChip } from "~/components/chips/CustomChip.jsx";
import QualityCheckRemoveItemButton from "./QualityCheckRemoveItemButton";
import { formParameterToEntityAction } from "~/components/entityAction/utils/entityActionsCore.js";
import FormEntryPoint from "~/components/entityAction/form/FormEntryPoint";
import { TableCellShippingMethodContent } from "~/components/table/cells/TableCellShippingMethod.jsx";
import { formatReadableDate, formatReadableDateAndTime } from "rylak-common";
import UploadedImage from "rylak-common/src/components/uploadImageQR/UploadedImage.jsx";
import HumanReadableDateTimeHover from "~/components/HumanReadableDateTimeHover.jsx";
import styles from "./ReportItemRow.module.scss";
import classNames from "classnames";

export function ReportItemTableCellProduct({ appProps, order, orderItem, customItem, style, className, highlightText, showBarCode = false }) {
    return (
        <TurnrTableCell tight>
            <div className={classNames("pt1 pb1", className)} style={style}>
                {orderItem && <AvatarAndItemName orderItem={orderItem} shopLink={false} order={order} highlightText={highlightText} showBarCode={showBarCode} />}
                {customItem && (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                        }}
                    >
                        {appProps && customItem?.data?.imageUUID && (
                            <div
                                style={{
                                    position: "relative",
                                    width: "45px",
                                    height: "45px",
                                    borderRadius: "45px",
                                    overflow: "hidden",
                                }}
                            >
                                <UploadedImage appProps={appProps} uuid={customItem?.data?.imageUUID} />
                            </div>
                        )}
                        <div>
                            {customItem?.data?.sku && <div>{customItem?.data?.sku}</div>}
                            {customItem?.data?.comment && <div className={"muted"}>{customItem?.data?.comment}</div>}
                        </div>
                    </div>
                )}
            </div>
        </TurnrTableCell>
    );
}

export function ReportItemTableCellReturnType({ appProps, orderItem }) {
    const complaint = orderItem?.complaint;
    return (
        <TurnrTableCell hide={"md"}>
            {orderItem?.type === "RETURN_ITEM" && (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "20px",
                    }}
                >
                    <CustomChip label={complaint ? "Complaint" : "Return"} colorType={CHIP_COLOR_TYPES.DONE} />
                    {complaint && <CustomerComplaintInfo appProps={appProps} customerComplaint={complaint} showImage showComplaintText />}
                </div>
            )}
        </TurnrTableCell>
    );
}

export default function ReportItemRow(props) {
    const {
        appProps,
        orderItem,
        customItem,
        order,
        actionFormButton = orderItem?.actionFormButton,
        actionFormAsEntityAction = formParameterToEntityAction({ formParameters: [actionFormButton] }, { jsonKey: null }),
        formValues = {},
        setFormValues,
        onRemoveClick,
        style,
        highlightText,
    } = props;

    const alreadyHandled = orderItem?.alreadyHandled;
    const previousReports = orderItem?.previousReports;

    return (
        <>
            <TurnrTableRow style={style}>
                <ReportItemTableCellProduct
                    appProps={appProps}
                    order={order}
                    orderItem={orderItem}
                    customItem={customItem}
                    className={styles["product-cell"]}
                    highlightText={highlightText}
                    showBarCode={true}
                />
                <ReportItemTableCellReturnType appProps={appProps} orderItem={orderItem} />
                <TurnrTableCell
                    tight={true}
                    // style={{ minWidth: "200px" }}
                    innerStyle={{
                        width: "auto",
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                    }}
                >
                    <div>
                        {alreadyHandled ? (
                            <div
                                style={{
                                    marginLeft: "auto",
                                    textAlign: "center",
                                }}
                            >
                                {previousReports?.length > 0 ? (
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "10px",
                                        }}
                                    >
                                        {previousReports?.map((previousReport) => {
                                            return (
                                                <CustomChip
                                                    key={previousReport?.createdAt}
                                                    colorType={CHIP_COLOR_TYPES.DONE}
                                                    tooltipTitle={formatReadableDateAndTime({ dateTime: previousReport?.createdAt })}
                                                    label={
                                                        <div>
                                                            <span className={"muted"} style={{ fontSize: "11px" }}>
                                                                Reported{" "}
                                                            </span>
                                                            {formatReadableDate({ dateTime: previousReport?.createdAt })}
                                                        </div>
                                                    }
                                                />
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <CustomChip
                                        colorType={CHIP_COLOR_TYPES.DONE}
                                        disableTooltip={true}
                                        label={
                                            <div>
                                                <span className={"muted"} style={{ fontSize: "11px" }}>
                                                    Reported
                                                </span>
                                            </div>
                                        }
                                    />
                                )}
                            </div>
                        ) : (
                            <TurnrGrid container alignItems={"center"} spacing={2} wrap={"nowrap"}>
                                <TurnrGrid item>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "20px",
                                            flexWrap: "nowrap",
                                        }}
                                    >
                                        <FormEntryPoint entityAction={actionFormAsEntityAction} formValues={{ ...formValues }} setFormValues={setFormValues} appProps={appProps} />
                                        {onRemoveClick && <QualityCheckRemoveItemButton onClick={onRemoveClick} />}
                                    </div>
                                </TurnrGrid>
                            </TurnrGrid>
                        )}
                    </div>
                </TurnrTableCell>
            </TurnrTableRow>
        </>
    );
}

export function ItemRowTitle({ title }) {
    return (
        <TurnrTableRow>
            <TurnrTableCell fullWidth={true} colSpan={4} style={{ background: "#fafbfb" }}>
                {title}
            </TurnrTableCell>
        </TurnrTableRow>
    );
}

export function ItemRowTitleOrder() {
    return <ItemRowTitle title={"Items on order"} />;
}

export function ItemRowTitleShipmentReturn({ appProps, shipment, orderReturn, highlightText }) {
    const label = shipment ? "Shipment" : "Return";

    return (
        <ItemRowTitle
            title={
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                    }}
                >
                    <div style={{ textWrap: "nowrap", minWidth: "105px" }}>Items on {label}</div>
                    <TableCellShippingMethodContent appProps={appProps} showShippingMethod={false} shipment={shipment} orderReturn={orderReturn} highlightText={highlightText} />
                    <div style={{ textWrap: "nowrap" }} className={"muted"}>
                        <HumanReadableDateTimeHover dateTime={shipment?.createdAt || orderReturn?.createdAt} />
                    </div>
                </div>
            }
        />
    );
}
